import { Component, OnInit } from '@angular/core';
import { MenuService } from './menu.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  public menuItems;
  constructor(protected menuService: MenuService) {
      this.menuItems = [];
      this.menuService.getMenuItems().subscribe({
          next: (val) => {
            console.log('setting menuitems to:', val);
            this.menuItems = val;
          }
      });
  }

  ngOnInit() {}


}



// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts